<template>
  <div
    :class="{
      'sliding-toggle': true,
      'sliding-toggle--active': localValue,
      'sliding-toggle--disabled': disabled
    }"
  >
    <label class="sliding-toggle__wrapper">
      <input class="sliding-toggle__input" type="checkbox" :disabled="disabled" :name="name" v-model="localValue" />
      <div class="sliding-toggle__track">
        <div class="sliding-toggle__knob" />
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: "SlidingToggle",
  props: {
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    value: {
      type: Boolean,
      default: false,
      required: false
    },
    name: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      localValue: false
    }
  },
  watch: {
    localValue(value) {
      this.$emit("input", value)
    },
    value: {
      immediate: true,
      handler(value) {
        this.localValue = value
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sliding-toggle {
  $root: &;
  padding: spacing(3px);

  &__wrapper {
    position: relative;

    align-self: flex-start;

    width: $spacing-32;

    cursor: pointer;
  }

  &__knob {
    position: absolute;
    top: spacing(-3px);

    width: spacing(18px);
    height: spacing(18px);

    background-color: $white;
    border: 2px solid $light-grey;
    border-radius: 50%;
    transform: translateX(0);

    transition: all 0.35s cubic-bezier(0, 1.1, 1, 1.1);
  }

  &__track {
    position: relative;

    width: spacing(34px);
    height: spacing(12px);

    background-color: $light-grey;
    border-radius: 10px;
  }

  &--active {
    #{$root}__knob {
      border: 2px solid $green;
      transform: translateX(100%);
    }
    #{$root}__track {
      background-color: $green;
    }
  }

  &--disabled {
    #{$root}__knob {
      border: 2px solid $lightest-grey;
    }

    #{$root}__track {
      background-color: $lightest-grey;
    }

    #{$root}__wrapper {
      cursor: default;
    }
  }

  @at-root #{$root}--active#{$root}--disabled {
    #{$root}__knob {
      border: 2px solid $green6;
    }

    #{$root}__track {
      background-color: $green6;
    }
  }

  &__input {
    position: absolute;

    width: 0;
    height: 0;

    opacity: 0;
  }
}
</style>
